<template>
  <div v-if="showModal" class="side__modal opened" id="modal__adding__customers__docs">
    <div class="">
      <div class="side__modal__content">
        <div class="modal__top">
          <div class="modal__header">
            <h3 class="modal__title">{{ $lang.app.SECTION_FILES }}</h3>
            <span class="modal__close" @click="closeModal">
            <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
          </div>
        </div>

        <Form class="modal__footer"
              @submit="submit"
              :initial-values="form"
              :validation-schema="schema">

          <div class="input__groups mb-4">
            <Field name="documentsFiles" v-slot="{field}">
              <FilesInput v-bind="field"
                          :model-value="form.documentsFiles"
                          @update:model-value="value => form.documentsFiles = value"
                          :label="$lang.app.SECTION_FILES"/>
            </Field>
            <ErrorMessage name="documentsFiles" class="input__fail"/>
          </div>

          <div class="between__buttons">
            <button type="button" class="button button__modal__close button--cancel"
                    @click="closeModal">{{ $lang.app.CANCEL }}</button>
            <button type="submit" class="relative button button__modal__close"
                    :disabled="submitting">
              {{ $lang.app.SAVE }}
              <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
                <div class="block animate-spin">
                  <RefreshIcon class="w-6 h-6 mirror-y"/>
                </div>
              </div>
            </button>
          </div>

        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import {Field, Form, ErrorMessage} from 'vee-validate'
import * as yup from "yup";
import applicationApi from "../../../../api/applicant/application"
import fileMixin from "../../../../mixins/fileMixin";
import FilesInput from "../../../FilesInput.vue";

export default {
  components: {
    Field,
    Form,
    ErrorMessage,
    FilesInput,
  },
  mixins: [fileMixin],
  data() {
    return {
      showModal: false,

      applicationId: null,
      documentId: null,

      submitting: false,
      form: {
        documentsFiles: []
      },
      schema: yup.object({
        documentsFiles: yup.mixed().required()
      }),
    };
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    async submit() {
      this.submitting = true
      const formData = new FormData()
      this.form.documentsFiles.forEach((item, index) => {
        formData.append(`documentsFiles[${index}]`, item)
      })
      applicationApi.storeDocumentFiles(this.applicationId, this.documentId, formData)
          .then(() => {
            this.closeModal()
            this.$emitter.emit('refresh-application', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          })
          .catch(error => {
            this.$snotify.error(error.response.data.message)
          }).finally(() => {
        this.submitting = false
      })
    }
  },
  beforeMount() {
    this.$emitter.on('open-add-document-files-modal', (payload) => {
      this.form.documentsFiles = []
      this.applicationId = payload.applicationId
      this.documentId = payload.documentId
      this.openModal()
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-add-document-files-modal')
  }
}
</script>
